import { useDispatch, useSelector } from 'react-redux'
import { initialState, setUser } from 'store/auth/userSlice'
import { apiSignIn, apiSignUp, getUser } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import { jwtDecode } from 'jwt-decode'
import { onEstablishmentSignOutSuccess } from 'store/establishment/sessionSlice'
import { setEstablishment } from 'store/establishment/establishmentSlice'

function useAuth() {
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const signIn = async (values) => {
        try {
            const resp = await apiSignIn({ username: values.username, password: values.password })
            if (resp.data) {
                const { token } = resp.data

                dispatch(onSignInSuccess(token))

                const user = jwtDecode(token)

                console.log(user)

                if (user) {

                    let loggedUser = await getUser(user?.username)

                    loggedUser = loggedUser.data['member'][0]
                    console.log(loggedUser)
                    dispatch(
                        setUser(
                            loggedUser || {
                                avatar: '',
                                username: 'Anonymous',
                                authority: [],
                                email: ''
                            }
                        )
                    )
                }

                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)

                return {
                    status: 'success',
                    message: ''
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString()
            }
        }
    }

    const signUp = async (values) => {
        try {
            const resp = await apiSignUp(values)


            if (resp.data) {
                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                if (resp.data.user) {


                    dispatch(
                        setUser(
                            resp.data.user || {
                                avatar: '',
                                username: 'Anonymous',
                                authority: ['USER'],
                                email: ''
                            }
                        )
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)
                return {
                    status: 'success',
                    message: ''
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString()
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(onEstablishmentSignOutSuccess())
        dispatch(setUser(initialState))
        dispatch(setEstablishment({}))
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => {
        //await apiSignOut()
        handleSignOut()
    }

    const user = useSelector(
        (state) => state.auth.user
    )

    return {
        authenticated: token && signedIn,
        user,
        signIn,
        signUp,
        signOut
    }
}

export default useAuth
